/**
 * WhatsApp / partner exit. Only `http:` / `https:` URLs are navigable.
 * Custom schemes, `window.close`, and invented Leap homepages are out of scope.
 */
export function isHttpUrl(url?: string | null): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

/** Assigns `window.location` only when the URL is http(s). Otherwise no-ops. */
export function returnToChat(url?: string | null): void {
  if (isHttpUrl(url) && url) {
    window.location.assign(url);
  }
}
